import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import { PhoneIcon, Mail, MapPinIcon } from 'lucide-react';
import Popup from './popup';
import './styles/contactform.css';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    mobileNumber: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [popup, setPopup] = useState({ show: false, type: '', message: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Basic validation
    if (!formData.fullName || !formData.email || !formData.mobileNumber) {
      setPopup({
        show: true,
        type: 'error',
        message: 'Please fill in all fields'
      });
      setIsSubmitting(false);
      return;
    }

    try {
      const templateParams = {
        from_name: formData.fullName,
        from_email: formData.email,
        mobile_number: formData.mobileNumber,
        to_email: 'info@yorkengineering.com.np', 
        message: `New contact request from ${formData.fullName}
                 Email: ${formData.email}
                 Mobile: ${formData.mobileNumber}`
      };

      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID_CONTACT,
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      // Show success message
      setPopup({
        show: true,
        type: 'success',
        message: 'Thank you for your message. We will contact you soon!'
      });

      // Reset form
      setFormData({
        fullName: '',
        email: '',
        mobileNumber: ''
      });
      
    } catch (error) {
      setPopup({
        show: true,
        type: 'error',
        message: 'Failed to send message. Please try again later.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  return (
    <div className="contact-container">
      {popup.show && (
        <Popup
          type={popup.type}
          message={popup.message}
          onClose={() => setPopup({ show: false, type: '', message: '' })}
          duration={5000}
        />
      )}
      
      <div className="contact-info-section">
        <h2>Contact Information</h2>
        <p className="chat-text">Say something to start a live chat!</p>
        
        <div className="contact-details">
          <div className="contact-item">
            <PhoneIcon className="icon" />
            <span>+977 9818207704</span>
          </div>
          <div className="contact-item">
            <Mail className="icon" />
            <span>info@yorkengineering.com.np</span>
          </div>
          <div className="contact-item">
            <MapPinIcon className="icon" />
            <span>Binayak Marg, Bhumiprasasan Chowk, Biratnagar -10</span>
          </div>
        </div>
        
        <div className="decorative-circles">
          <div className="circle circle-1"></div>
          <div className="circle circle-2"></div>
        </div>
      </div>

      <div className="form-section">
        <h1>Request A Call to Know more</h1>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="fullName">Full Name</label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="mobileNumber">Mobile Number</label>
            <input
              type="tel"
              id="mobileNumber"
              name="mobileNumber"
              value={formData.mobileNumber}
              onChange={handleChange}
              required
            />
          </div>

          <button 
            type="submit" 
            className={`submit-btn ${isSubmitting ? 'submitting' : ''}`}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending...' : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;